import * as React from "react"

interface Props {
  color?: string
}

export const IOSArrowLeftIcon: React.FunctionComponent<Props> = ({ color = "white" }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.225 2L18 3.775L9.775 12L18 20.225L16.225 22L6.225 12L16.225 2Z" fill="#616161" />
  </svg>
)

export const IOSArrowRightIcon: React.FunctionComponent<Props> = ({ color = "white" }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.025 22L6.25 20.225L14.475 12L6.25 3.775L8.025 2L18.025 12L8.025 22Z" fill="#616161" />
  </svg>
)
